/**
 * Máy này đã mở tờ "Mã QR cho khách" chưa — để bước "Mã QR cho khách" của thẻ Chuẩn bị tiệm tính XONG ngay khi chủ đã
 * mở mã (ADR-118). Trước đây bước này chỉ xong khi có khách đầu tiên đặt qua Zalo, nên tiệm mới (mã QR đã có) không
 * bao giờ qua được trước khi có khách. Không cần migration: cờ nhớ theo (tiệm, máy) như chi nhánh đang dùng (ADR-101).
 *
 * Bộ nhớ trống / ném lỗi (chế độ riêng tư) = coi như chưa mở; không bao giờ làm hỏng màn. Máy khác của chủ vẫn thấy
 * bước này chưa xong tới khi có lịch đầu tiên hoặc mở mã ở máy đó — chấp nhận (thẻ chỉ là lời nhắc).
 */
import { type KhoNho, khoNhoMay } from './chi-nhanh-dang-dung.ts'

export function khoaDaMoMaQr(tiem: string): string {
  return `sapa.quay.daMoMaQr.${tiem}`
}

export function daMoMaQr(kho: Pick<KhoNho, 'getItem'> | null, tiem: string): boolean {
  if (kho === null) return false
  try {
    return kho.getItem(khoaDaMoMaQr(tiem)) === '1'
  } catch {
    return false
  }
}

export function ghiDaMoMaQr(kho: Pick<KhoNho, 'setItem'> | null, tiem: string): void {
  if (kho === null) return
  try {
    kho.setItem(khoaDaMoMaQr(tiem), '1')
  } catch {
    // Không nhớ được thì lần sau hỏi lại. Không sao.
  }
}

/** Đọc cờ trên máy này (`localStorage` nếu dùng được). */
export function daMoMaQrTrenMay(tiem: string): boolean {
  return daMoMaQr(khoNhoMay(), tiem)
}

/** Ghi cờ trên máy này. */
export function ghiDaMoMaQrTrenMay(tiem: string): void {
  ghiDaMoMaQr(khoNhoMay(), tiem)
}
